import React, { Component } from 'react';
import { fetchModel } from '../../components/HelperComponents/FetchExtension';
import { Fstyr } from '../../components/FstyrComponents/Fstyr.js';
import { BusinessCardVm } from '../../Models/BusinessCardVm';
import { GetStatusVm, GetStatusName, GetStatusId} from '../../components/HelperComponents/StatusHelper';
import { DateFormatter } from '../../components/HelperComponents/DateFormatter'
import { filterCardStatuses, filterCardStatusesPolice } from '../../components/HelperComponents/FilterCardStatuses.js';
import URL from '../../Constants/URL.js'
import { ValidationType } from '../../Constants/ValidationTypes';
import { formatAddress } from '../../components/HelperComponents/AddressFormatter';
import { cardNumberFromHRef } from '../../components/HelperComponents/GetCardNumberFromHRef.js';

type Props = {};

type State = {
  cardFound: boolean,
  changeStatus: boolean,
  showSpinner: boolean,
  newCardStatusId: number,

  cardNumberInput: string,
  cardNumberIsValid: boolean,
  searchButtonPressed: boolean,

  businessCardVm: BusinessCardVm,
};


export class SearchBusinessCard extends Component<Props, State> {
  static displayName = SearchBusinessCard.name;
  private toastRef: React.RefObject<any>;
  private baseState: State;

  constructor(props: Props) {
    super(props);
    this.toastRef = React.createRef();

    this.state = {
      cardFound: false,
      changeStatus: false,
      showSpinner: false,
      newCardStatusId: 0,

      cardNumberInput: "DK",
      cardNumberIsValid: false,
      searchButtonPressed: false,

      businessCardVm: new BusinessCardVm(),
    };

    this.baseState = this.state;
  }

  componentDidMount() {
    this.setState({ cardNumberInput: cardNumberFromHRef() }, () => {
      if (this.state.cardNumberInput.length === 16) {
        this.fetchBusiness()
      }
    })
  }

  fetchBusiness() {
    this.setState({ searchButtonPressed: true }, () => {
      if (this.state.cardNumberIsValid) {
        this.setState({ showSpinner: true })
        this.clearPage(false);
        fetchModel("GET", URL + "/api/BusinessCard/GetBusinessCardsByCardNumber", this.state.cardNumberInput, BusinessCardVm)
          .then(model => {
            this.setState({ businessCardVm: model[0], cardFound: true })
          })
          .catch(error => this.showErrorToast(error))
          .finally(() => this.setState({ showSpinner: false }))
      }
    })
  }

  clearPage(clearInput: boolean) {
    if (clearInput) {
      this.setState(this.baseState)
    } else {
      this.setState({
        cardFound: false,
        changeStatus: false,
        showSpinner: false,
        newCardStatusId: 0,
        businessCardVm: new BusinessCardVm(),
      })
    }
  }

  showErrorToast(error: string) {
    this.setState({ showSpinner: false })
    if (error === "No result") {
      this.toastRef.current.show("Virksomhedskort", "Der findes ikke et virksomhedskort på det søgte kortnummer", "warning")
    }
    else if (error === "Failed response") {
      this.toastRef.current.show("Fejl", "Kan ikke forbinde til databasen", "error")
    }
    else {
      this.toastRef.current.show("Fejl", "Der skete en ukendt fejl", "error")
    }
  }

  changeCardStatus() {
    let model = Object.assign({}, this.state.businessCardVm);
    model.Status = GetStatusVm(this.state.newCardStatusId)
    let success = true

    let requestInfo = {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify(model)
    }

    fetch(URL + "/api/businesscard/ChangeCardStatus", requestInfo)
      .then(response => response.json())
      .then((result) => {
        if (!result.valid) {
          success = false
        }
        this.fetchBusiness();

      })
      .catch(() => {
        success = false;

      })
      .finally(
        () => {
          success ? this.toastRef.current.show("Skift status", "Kortets status er skiftet.", "success")
            : this.toastRef.current.show("Skift status", "Kortets status blev ikke skiftet.", "error")
        }
      )
  }

  render() {
    return (
      <>
        <Fstyr.Toast ref={this.toastRef} />
        <Fstyr.Segment
          title="Søg Virksomhedskort"
          isPageTitle={true}
        >
          <div className="fstyr-right-top-button-group">
            <Fstyr.Button
              label="Ryd side"
              onClick={() => { this.clearPage(true) }}
            />
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment
          title="Angiv kortnummer"
        >
          <Fstyr.Input
            value={this.state.cardNumberInput}
            label="Kortnummer"
            onChange={(value: string) => this.setState({ cardNumberInput: value })}
            setValid={(valid: boolean) => this.setState({ cardNumberIsValid: valid })}
            buttonClicked={this.state.searchButtonPressed}
            onValidatingButtonPressed={() => this.setState({ searchButtonPressed: true })}
            validation={true}
            validationType={ValidationType.cardNumber}
            errorBodyText={"Forkert format (landekode + 14 tegn)"}
            onEnterPressed={() => this.fetchBusiness()}
          />

          <div className="fstyr-left-button-group">
            <Fstyr.Button
              label="Søg"
              onClick={() => {
                this.fetchBusiness()
              }}
              disabled={this.state.showSpinner}
            />
            <Fstyr.Spinner
              show={this.state.showSpinner}
            />
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment
          title="Virksomhedskortinformation"
        >
          <div className="fstyr-attention-box">
            <Fstyr.Input
              label="Kortnummer"
              readonly={true}
              value={this.state.businessCardVm.CardNumber}
              direction="row"
            />
            <Fstyr.Input
              label="Kortholder"
              readonly={true}
              value={this.state.businessCardVm.Business.Name}
              direction="row"
            />
            <Fstyr.Input
              label={this.state.businessCardVm.Business.Cvr.length === 8 ? "Kortholder CVR" : "Kortholder CPR"}
              readonly={true}
              value={this.state.businessCardVm.Business.Cvr}
              direction="row"
            />
            {(this.state.businessCardVm && this.state.businessCardVm.Business.Cvr.length === 8) &&
              <Fstyr.Input
                label="Virksomhedsadresse"
                readonly={true}
                value={formatAddress(this.state.businessCardVm.Business.Address, true)}
                direction="row"
              />
            }
            <Fstyr.Input
              label="Gyldighedsperiode"
              readonly={true}
              value={this.state.cardFound ? DateFormatter(this.state.businessCardVm.ValidFrom) + "  -  " + DateFormatter(this.state.businessCardVm.ValidTo) : ""}
              direction="row"
            />
            <Fstyr.Input
              label="Status på kort"
              direction="row"
              readonly={true}
              value={this.state.cardFound ? GetStatusName(this.state.businessCardVm.Status.Id) : ""}
            />
            <Fstyr.Button
              label="Skift status"
              onClick={() => {
                if (this.state.cardFound) {
                  this.setState({ changeStatus: true })
                }
              }}
              disabled={!this.state.cardFound}
            />
            {this.state.changeStatus &&
              <div style={{ marginTop: 15, maxWidth: 340 }}>
                <div className="alert alert-info" style={{ marginTop: 10 }}>
                  <div className="alert-body" style={{ height: "100%" }}>
                    <p className="alert-heading">Ekstra oplysninger</p>
                    <p className="alert-text">Udfyld de nedenstående oplysninger.</p>
                    <Fstyr.Dropdown
                      items={global.config.isPolice ? filterCardStatusesPolice(require('../../assets/CardStatus.json')) : filterCardStatuses(require('../../assets/CardStatus.json'))}
                      width={"100%"}
                      onItemSelected={(status) => this.setState({ newCardStatusId: GetStatusId(require('../../assets/CardStatus.json'), status) })}
                      label="Ny status"
                    />
                    <Fstyr.Input
                      label="Dato for ændring"
                      direction="column"
                      readonly={true}
                      value={DateFormatter(new Date())}
                    />
                    <div className='fstyr-right-button-group' >
                      <Fstyr.Button
                        label="Gem"
                        onClick={() => { this.changeCardStatus() }}
                        disabled={this.state.newCardStatusId === this.baseState.newCardStatusId}
                      />
                      <Fstyr.Button
                        label="Annullér"
                        type="secondary"
                        onClick={() => this.setState({
                          changeStatus: false,
                          newCardStatusId: 0
                        })}
                      />
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </Fstyr.Segment>
      </>
    );
  }
}
